import { PlusInSquareIcon } from "assets/icons";
import { useBoolean } from "hooks";
import { useState } from "react";
import { Button, Pagination, SearchInput } from "ui";

import {
  CustomCouponsTable,
  DeleteCouponModal,
  CouponModal
} from "../../components";
import { CouponType } from "../../constants";
import { useCouponsList } from "../../hooks";

import styles from "./CustomCoupons.module.scss";

const CustomCoupons = () => {
  const {
    coupons,
    totalItems,
    searchValue,
    page,
    isLoading,
    sorting,
    setSorting,
    setSearchValue,
    setPage
  } = useCouponsList(CouponType.CustomCoupon);

  const [deletingCouponId, setDeletingCouponId] = useState<string | null>(null);

  const {
    value: isCouponModalOpen,
    setTrue: openCouponModal,
    setFalse: closeCouponModal
  } = useBoolean(false);

  return (
    <>
      <div className={styles.headerLine}>
        <SearchInput
          value={searchValue}
          onChange={setSearchValue}
          placeholder={"Search..."}
        />

        <Button
          title={"New Coupon"}
          icon={<PlusInSquareIcon />}
          onClick={openCouponModal}
        />
      </div>

      <CustomCouponsTable
        coupons={coupons}
        sorting={sorting}
        setSorting={setSorting}
        isLoading={isLoading}
        onDeleteCoupon={setDeletingCouponId}
      />

      <Pagination
        currentPage={page}
        onChange={setPage}
        totalItems={totalItems}
      />

      <CouponModal
        couponType={CouponType.CustomCoupon}
        isOpen={isCouponModalOpen}
        onClose={closeCouponModal}
      />

      {deletingCouponId && (
        <DeleteCouponModal
          id={deletingCouponId}
          isOpen={!!deletingCouponId}
          couponType={CouponType.CustomCoupon}
          onClose={() => setDeletingCouponId(null)}
        />
      )}
    </>
  );
};

export default CustomCoupons;
